module.exports = __webpack_public_path__ + "img/galery-kx5600-3.6bc6684d.png";